/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Fallback in case assets/intelligems-custom-price.js did not load — keeps the
// personalization subtotals working on the theme's own prices.
window.igGetSubtotalCents = window.igGetSubtotalCents || function (el) {
    return Number(el.dataset.currentVariantPrice || 0) + Number(el.dataset.upsellsTotalPrice || 0)
}

// General
if (window.FilePond) {
    // eslint-disable-next-line no-undef
    FilePond.registerPlugin(FilePondPluginImagePreview)
    // eslint-disable-next-line no-undef
    FilePond.registerPlugin(FilePondPluginImageCrop)
    // eslint-disable-next-line no-undef
    FilePond.registerPlugin(FilePondPluginImageResize)
    // eslint-disable-next-line no-undef
    FilePond.registerPlugin(FilePondPluginImageTransform)
    // eslint-disable-next-line no-undef
    FilePond.registerPlugin(FilePondPluginFileValidateType)
}

// Product options
// A named binder so the theme editor can rebind options in a section it just re-rendered
const bindProductOption = ($option) => {
    $option.addEventListener('change', () => {
        const $form = $option.closest('form[action="/cart/add"]')

        const selectedOptions = []

        $form.querySelectorAll('.product-option').forEach(($option) => {
            if ($option.type === 'radio') {
                if ($option.checked) {
                    selectedOptions.push($option.value)
                }
            } else {
                selectedOptions.push($option.value)
            }
        })

        const selectedVariant = JSON.parse($form.dataset.variants).find(
            (variant) => JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
        )

        const $addToCartBtn = $form.querySelector('.btn-atc')

        console.log(selectedVariant)

        if (selectedVariant) {
            $form.querySelector('select[name="id"]').value = selectedVariant.id

            if (selectedVariant.available) {
                $addToCartBtn.disabled = false
                $addToCartBtn.querySelector('span').textContent = $addToCartBtn.dataset.textAddToCart
            } else {
                $addToCartBtn.disabled = true
                $addToCartBtn.querySelector('span').textContent = $addToCartBtn.dataset.textSoldOut
            }

            const productPriceContainer = $form.closest('.product').querySelector('.product-price-container')

            productPriceContainer.querySelector('.product-price-final')
                .textContent = window.formatMoney(selectedVariant.price)
            productPriceContainer.querySelector('.product-price-final')
                .setAttribute('data-variant-id', selectedVariant.id)

            const comparePrice = productPriceContainer.querySelector('.product-price-compare')

            if (comparePrice) {
                // Intelligems resolves the compare-at price from this element's own
                // data-variant-id, so it has to be kept in sync on every variant change.
                comparePrice.setAttribute('data-variant-id', selectedVariant.id)

                if (selectedVariant.compare_at_price) {
                    comparePrice.textContent = window.formatMoney(selectedVariant.compare_at_price)
                    comparePrice.classList.remove('d-none')
                } else {
                    comparePrice.classList.add('d-none')
                }
            }

            const discountedPrice = productPriceContainer.querySelector('.product-price-final-discounted')

            if (discountedPrice) {
                const discount = parseFloat(discountedPrice.dataset.discount)
                discountedPrice.textContent = window.formatMoney(selectedVariant.price * discount)
                discountedPrice.setAttribute('data-variant-id', selectedVariant.id)
            }

            document.querySelectorAll('#form-custom-pet-portrait .product-price-final').forEach(el => {
                el.setAttribute('data-current-variant-price', selectedVariant.price)
                el.setAttribute('data-variant-id', selectedVariant.id)
                // Subtotal = Intelligems' tested price for this variant + selected add-ons.
                el.textContent = window.formatMoney(window.igGetSubtotalCents(el))
            })

            if ($form.dataset.historyPush !== 'false') {
                window.history.replaceState({}, '', `${$form.dataset.productUrl}?variant=${selectedVariant.id}`)
            }

            if (selectedVariant.featured_media) {
                const event = new CustomEvent('slideProductImageGallery', {
                    detail: selectedVariant.featured_media.position - 1
                })
                window.dispatchEvent(event)

                if ($option.closest('.bundle-and-save')) {
                    const carousel = $option.closest('.product').querySelector('.product-carousel.carousel')
                    if (carousel) {
                        const bsCarosuel = bootstrap.Carousel.getOrCreateInstance(carousel)
                        bsCarosuel.to(selectedVariant.featured_media.position - 1)
                    }
                }
            }

            if ($option.closest('form').querySelector('button[data-check-disabled-btn')) {
                if (selectedVariant.available) {
                    $option.closest('form').querySelector('button[data-check-disabled-btn').disabled = false
                    $option.closest('form').querySelector('button[data-check-disabled-btn').textContent = 'Next →'
                    $option.closest('form').querySelector('[data-variant-soldout-alert]').setAttribute('hidden', 'hidden')
                } else {
                    $option.closest('form').querySelector('button[data-check-disabled-btn').disabled = true
                    $option.closest('form').querySelector('button[data-check-disabled-btn').textContent = 'Sold out'
                    $option.closest('form').querySelector('[data-variant-soldout-alert]').removeAttribute('hidden')
                }
            }

            if ($option.closest('form').querySelector('#checkbox-embroidery-pet-name')) {
                if (JSON.stringify(selectedOptions).includes('Full Color')) {
                    $option.closest('form').querySelector('#embroidery-pet-name-wrapper').setAttribute('hidden', 'hidden')
                    $option.closest('form').querySelector('#checkbox-embroidery-pet-name').disabled = true
                    $option.closest('form').querySelector('#checkbox-embroidery-pet-name').checked = false
                } else {
                    $option.closest('form').querySelector('#embroidery-pet-name-wrapper').removeAttribute('hidden')
                    $option.closest('form').querySelector('#checkbox-embroidery-pet-name').disabled = false
                }
            }

            if ($option.closest('form').querySelector('[data-count-pendants]')) {
                let noOfPendants = 1

                if (selectedVariant.title.includes('Two')) {
                    noOfPendants = 2
                } else if (selectedVariant.title.includes('Three')) {
                    noOfPendants = 3
                } else if (selectedVariant.title.includes('Four')) {
                    noOfPendants = 4
                }

                $option.closest('form').querySelectorAll('[data-count-pendants]').forEach(elem => {
                    if (noOfPendants < Number(elem.dataset.countPendants)) {
                        elem.setAttribute('hidden', 'hidden')
                        elem.querySelectorAll('input').forEach(input => {
                            input.required = false
                        })
                        elem.querySelectorAll('input.form-control').forEach(input => {
                            input.disabled = true
                        })
                    } else {
                        elem.removeAttribute('hidden', 'hidden')
                        elem.querySelectorAll('input').forEach(input => {
                            input.required = true
                        })
                        elem.querySelectorAll('input.form-control').forEach(input => {
                            input.disabled = false
                        })
                    }
                })
            }

        } else {
            $option.closest('form').querySelector('button[data-check-disabled-btn').disabled = true
            $option.closest('form').querySelector('button[data-check-disabled-btn').textContent = 'Unavailable'

            $addToCartBtn.disabled = true
            $addToCartBtn.querySelector('span').textContent = $addToCartBtn.dataset.textUnavailable

            if ($form.dataset.historyPush !== 'false') {
                window.history.replaceState({}, '', $form.dataset.productUrl)
            }
        }
    })
}
document.querySelectorAll('.product-option').forEach(bindProductOption)

// Product Media Gallery - Init Splide
const initProductMediaGalleries = () => {
    document.querySelectorAll('.product-media-gallery:not(.init)').forEach((galleryElement) => {
        const mainEl = galleryElement.querySelector('.main-splide')
        const thumbsEl = galleryElement.querySelector('.thumbs-splide')

        if (!mainEl || !thumbsEl) {
            return
        }

        galleryElement.classList.add('init')

        const main = new Splide(mainEl, {
            type: 'fade',
            rewind: true,
            pagination: false,
            arrows: true
        })

        const thumbs = new Splide(thumbsEl, {
            gap: 12,
            rewind: true,
            arrows: false,
            pagination: false,
            perPage: 5,
            isNavigation: true,
            breakpoints: {
                575: {
                    perPage: 3
                }
            }
        })

        window.addEventListener('slideProductImageGallery', (e) => {
            main.go(e.detail)
        }, false)

        main.sync(thumbs)
        main.mount()
        thumbs.mount()
    })
}

// Product Media Gallery - Sticky position on scroll (only in desktop)
const initProductMediaGallerySitcky = () => {
    document.querySelectorAll('.product-media-gallery').forEach((galleryElement) => {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 20) {
                const navbarHeight = document.querySelector('#shopify-section-header.sticky-top')?.clientHeight || 0
                galleryElement.style.position = 'sticky'
                galleryElement.style.top = `${navbarHeight + 20}px`
            }
        })
    })
}

initProductMediaGalleries()
initProductMediaGallerySitcky()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.product-media-gallery')) {
        initProductMediaGalleries()
        initProductMediaGallerySitcky()
    }
})

document.addEventListener('shopify:block:select', (e) => {
    if (e.target.closest?.('.product-carousel-block') || e.target.querySelector?.('.product-media-gallery')) {
        initProductMediaGalleries()
    }
})

// Delivery Info
const initDeliveryInfo = () => {
    document.querySelectorAll('.product-delivery-info').forEach(($el) => {
        const minDays = Number($el.dataset.minDays)
        const maxDays = Number($el.dataset.maxDays)

        const minDaysText = dayjs().add(minDays, 'day').format('dddd, MMM D')
        const maxDaysText = dayjs().add(maxDays, 'day').format('dddd, MMM D')

        $el.querySelector('span').insertAdjacentHTML('beforeend', `
            <b>${minDaysText}</b>
                - 
            <b>${maxDaysText}</b>
        `)
    })
}
initDeliveryInfo()

// Product list item - Handle variant change
window.onChangeProductListItemVariant = (e) => {
    const variantImageId = e.target.options[e.target.selectedIndex].dataset.variantImageId

    if (variantImageId) {
        const $carousel = e.target.closest('.product-list-item').querySelector('.carousel')

        if ($carousel) {
            let carouselItemIndex = 0

            $carousel.querySelectorAll('.carousel-item').forEach((el, index) => {
                if (el.dataset.imageId === variantImageId) {
                    carouselItemIndex = index
                }
            })

            const carousel = bootstrap.Carousel.getOrCreateInstance($carousel)
            carousel.to(carouselItemIndex)
        }
    }
}

/*
    Step through Start (section)
    https://westandwillow.com/pages/custom-pet-portraits
*/
// const initStepThroughStart = () => {
//     const wrapper = document.querySelector('#step-through-start')

//     if (!wrapper) {
//         return
//     }

//     const carousel = bootstrap.Carousel.getOrCreateInstance('#step-through-start .carousel')

//     wrapper.querySelectorAll('[name="portrait-style"]').forEach((radio, index) => {
//         radio.addEventListener('change', (e) => {
//             carousel.to(index)

//             wrapper.querySelectorAll('[name="pets-count"] + label img').forEach((img) => {
//                 img.setAttribute('src', index === 0 ? img.dataset.imgModern : img.dataset.imgLine)
//             })
//         })
//     })

//     wrapper.querySelectorAll('[name="pets-count"]').forEach((radio, index) => {
//         radio.addEventListener('change', (e) => {
//             wrapper.querySelector('.product-price-final').textContent = radio.dataset.price

//             const style = wrapper.querySelector('[name="portrait-style"]:checked').value

//             switch (radio.value) {
//             case '1 pet':
//                 carousel.to(style === 'modern' ? 0 : 0)
//                 break
//             case '2 pets':
//                 carousel.to(style === 'modern' ? 1 : 0)
//                 break
//             case '3 pets':
//                 carousel.to(style === 'modern' ? 2 : 0)
//                 break
//             case '4 pets':
//                 carousel.to(style === 'modern' ? 3 : 0)
//                 break
//             }
//         })
//     })

//     wrapper.querySelector('#step-through-start-step-1 .btn-next').addEventListener('click', () => {
//         wrapper.querySelector('#step-through-start-step-1').style.display = 'none'
//         wrapper.querySelector('#step-through-start-step-2').style.display = 'block'
//     })

//     wrapper.querySelector('#step-through-start-step-2 .btn-prev').addEventListener('click', () => {
//         wrapper.querySelector('#step-through-start-step-1').style.display = 'block'
//         wrapper.querySelector('#step-through-start-step-2').style.display = 'none'
//     })

//     wrapper.querySelector('#step-through-start-step-2 .btn-next').addEventListener('click', () => {
//         const style = wrapper.querySelector('[name="portrait-style"]:checked').value
//         const petCount = wrapper.querySelector('[name="pets-count"]:checked').value

//         let productHandle = ''

//         switch (petCount) {
//         case '1 pet':
//             productHandle = style === 'modern' ? 'custom-one-pet-portrait' : 'custom-line-drawing-one-pet-portrait'
//             break
//         case '2 pets':
//             productHandle = style === 'modern' ? 'custom-two-pet-portrait' : 'custom-line-drawing-two-pet-portrait'
//             break
//         case '3 pets':
//             productHandle = style === 'modern' ? 'custom-three-pet-portrait' : 'custom-line-drawing-three-pet-portrait'
//             break
//         case '4 pets':
//             productHandle = style === 'modern' ? 'custom-four-pet-portrait' : 'custom-line-drawing-four-pet-portrait'
//             break
//         default:
//             break
//         }

//         window.location.href = `/products/${productHandle}`
//     })

// }
// initStepThroughStart()


/*
    Step through Start - Memorial (section)
    https://westandwillow.com/pages/custom-pet-portraits
*/
const initStepThroughStartMemorial = () => {
    const wrapper = document.querySelector('#step-through-start-memorial')

    if (!wrapper) {
        return
    }

    const carousel = bootstrap.Carousel.getOrCreateInstance('#step-through-start-memorial .carousel')

    wrapper.querySelectorAll('[name="portrait-style"]').forEach((radio, index) => {
        radio.addEventListener('change', (e) => {
            carousel.to(index)
            wrapper.querySelector('a.btn-next').setAttribute('href', `/products/${radio.dataset.productHandle}`)
        })
    })
}
initStepThroughStartMemorial()

/*
    Custom Pet Portrait - custom form
*/
const initCustomPetPortraitForm = () => {
    const form = document.querySelector('#form-custom-pet-portrait')

    if (!form) { return }

    // In the theme editor, skip the photo / pet name checks and remember the open step,
    // so merchants can preview every step and keep their place when a setting re-renders the section
    const inThemeEditor = window.Shopify?.designMode === true
    const editorStepKey = `ww-editor-step:${window.location.pathname}`

    if (inThemeEditor) {
        let savedStep = null
        try { savedStep = sessionStorage.getItem(editorStepKey) } catch (error) { /* storage blocked */ }

        if (savedStep && form.querySelector(`[data-step="${savedStep}"]`)) {
            form.querySelectorAll('[data-step]').forEach((step) => {
                step.style.display = step.dataset.step === savedStep ? 'block' : 'none'
            })
        }
    }

    // let pet1File, pet2File, pet3File

    form.querySelectorAll('.form-step-btn-show-hide').forEach((btn) => {
        btn.addEventListener('click', () => {
            let canContinue = true

            const alertElem = form.querySelector('#form-custom-pet-portrait-alert')

            if (!inThemeEditor && btn.classList.contains('btn-next') && btn.closest('[data-step="3')) {
                form.querySelectorAll('[data-step="3"] [required]').forEach((elem) => {
                    if (elem.type === 'file' && elem.files.length === 0) {
                        canContinue = false
                    } else if (elem.type === 'text' && elem.value.length === 0) {
                        canContinue = false
                    }
                })
            }

            // Validate personalized gift note fields if checkbox is checked
            if (!inThemeEditor && btn.classList.contains('btn-next') && btn.closest('[data-step="4')) {
                const giftNoteCheckbox = form.querySelector('#checkbox-personalized-gift-note')
                if (giftNoteCheckbox && giftNoteCheckbox.checked) {
                    const giftNoteOccasion = form.querySelector('#personalized-gift-note-occasion')
                    const giftNoteMessage = form.querySelector('#personalized-gift-note-message')
                    
                    if (giftNoteOccasion && (!giftNoteOccasion.value || giftNoteOccasion.value === '')) {
                        canContinue = false
                        alertElem.style.display = 'block'
                        alertElem.textContent = 'Please select a gift occasion.'
                    } else if (giftNoteMessage && (!giftNoteMessage.value || giftNoteMessage.value.trim().length === 0)) {
                        canContinue = false
                        alertElem.style.display = 'block'
                        alertElem.textContent = 'Please write your gift note message.'
                    }
                }
            }

            if (canContinue) {
                form.querySelector(`[data-step="${btn.dataset.hideStep}"]`).style.display = 'none'
                form.querySelector(`[data-step="${btn.dataset.showStep}"]`).style.display = 'block'

                alertElem.style.display = 'none'
                alertElem.textContent = ''

                if (inThemeEditor) {
                    try { sessionStorage.setItem(editorStepKey, btn.dataset.showStep) } catch (error) { /* storage blocked */ }
                }
            } else {
                alertElem.style.display = 'block'
                alertElem.textContent = 'Please add all required information.'
            }

            setTimeout(() => {
                document.querySelector('#product-content-area').scrollIntoView({ behavior: 'smooth' })
            }, 250)
        })
    })

    form.querySelectorAll('#form-option-framing-swicher input[type="radio"]').forEach((input) => {
        input.addEventListener('change', () => {
            const bsCollapseFrame = new bootstrap.Collapse('#form-option-framing-collapse-frame')
            const bsCollapseNoFrame = new bootstrap.Collapse('#form-option-framing-collapse-no-frame')

            bsCollapseFrame.toggle()
            bsCollapseNoFrame.toggle()

            if (input.id === 'framing-swicher-framing') {
                form.querySelector('#option-frame-option-black').checked = true
                form.querySelector('#option-frame-option-poster-only').dispatchEvent(new Event('change'))
            } else {
                form.querySelector('#option-frame-option-poster-only').checked = true
                form.querySelector('#option-frame-option-poster-only').dispatchEvent(new Event('change'))
            }
        })
    })

    form.querySelectorAll('[data-step="3"] input[type="file"]').forEach((input, index) => {
        // console.log(input)

        const pondPhoto = FilePond.create(input, {
            storeAsFile: true,
            acceptedFileTypes: ["image/jpg", "image/jpeg", "image/png", "image/gif", "image/bmp", "image/heic"],
            labelIdle: `<span class="filepond--drop-label--icon me-3"></span> Drag and drop your pet's photo ${index + 1} or <span class="filepond--label-action ms-1">Browse</span>`,
            imageResizeTargetWidth: 1200
        })

        pondPhoto.on('addfile', (error, file) => {
            // console.log(file)

            if (!error) {
                form.querySelector(`#input-pet-name-${index + 1}-wrapper`).style.display = 'block'
            }

            // switch (index) {
            // case 0: pet1File = file.file
            //     break
            // case 1: pet2File = file.file
            //     break
            // case 2: pet3File = file.file
            // }
        })
    })

    // form.querySelector('[data-show-step="5"]').addEventListener('click', () => {
    //     const backgroundValue = form.querySelector('[name="option-background-color"]:checked').value
    //     const backgroundImgEl = form.querySelector('[name="option-background-color"]:checked').nextElementSibling.querySelector('img')
    //     const framingValue = form.querySelector('[name="option-frame-option"]:checked').value
    //     const framingImgEl = form.querySelector('[name="option-frame-option"]:checked').nextElementSibling.querySelector('img')
    //     const sizeValue = form.querySelector('[name="option-size"]:checked').value
    //     const sizeImgEl = form.querySelector('[name="option-size"]:checked').nextElementSibling.querySelector('img')

    //     form.querySelector('[data-step="5"] [data-review="background"] .card-title span').textContent = backgroundValue
    //     form.querySelector('[data-step="5"] [data-review="background"]').insertAdjacentElement('afterbegin', backgroundImgEl)
    //     form.querySelector('[data-step="5"] [data-review="framing"] .card-title span').textContent = framingValue
    //     form.querySelector('[data-step="5"] [data-review="framing"]').insertAdjacentElement('afterbegin', framingImgEl)
    //     form.querySelector('[data-step="5"] [data-review="size"] .card-title span').textContent = sizeValue
    //     form.querySelector('[data-step="5"] [data-review="size"]').insertAdjacentElement('afterbegin', sizeImgEl)

    //     const petName1 = form.querySelector('[name="properties[Pet Name 1]"]')?.value
    //     const petName2 = form.querySelector('[name="properties[Pet Name 2]"]')?.value
    //     const petName3 = form.querySelector('[name="properties[Pet Name 3]"]')?.value

    //     form.querySelector('[data-step="5"] [data-review="photo-1"] img').setAttribute('src', URL.createObjectURL(pet1File))
    //     form.querySelector('[data-step="5"] [data-review="photo-1"] .card-title span').textContent = petName1

    //     if (petName2) {
    //         form.querySelector('[data-step="5"] [data-review="photo-2"] img').setAttribute('src', URL.createObjectURL(pet2File))
    //         form.querySelector('[data-step="5"] [data-review="photo-2"] .card-title span').textContent = petName2
    //     }

    //     if (petName3) {
    //         form.querySelector('[data-step="5"] [data-review="photo-3"] img').setAttribute('src', URL.createObjectURL(pet3File))
    //         form.querySelector('[data-step="5"] [data-review="photo-3"] .card-title span').textContent = petName3
    //     }

    //     const note = form.querySelector('#form-properties-note').value

    //     form.querySelector('[data-step="5"] [data-review="note"] .card-title').insertAdjacentHTML('afterend', `<p class="mb-0">${note}</p>`)

    //     const skipTheLine = form.querySelector('#checkbox-skip-the-line:checked')
    //     const digitalDownload = form.querySelector('#checkbox-digital-download:checked')

    //     if (skipTheLine) {
    //         form.querySelector('[data-step="5"] [data-review="skip-the-line"] span').textContent = '(✓)'
    //     }

    //     if (digitalDownload) {
    //         form.querySelector('[data-step="5"] [data-review="digital-download"] span').textContent = '(✓)'
    //     }
    // })

    form.querySelectorAll('.product-option').forEach(productOption => {
        productOption.addEventListener('chnage', () => {

        })
    })

    form.querySelectorAll('[data-step="4"] input, #artwork-proof-checkbox').forEach((input) => {
        input.addEventListener('change', (e) => {
            form.querySelectorAll('.product-price-final').forEach(el => {
                let value = 0
                if (e.target.checked) {
                    value = Number(el.dataset.upsellsTotalPrice || 0) + Number(input.dataset.price)
                } else {
                    value = Number(el.dataset.upsellsTotalPrice || 0) - Number(input.dataset.price)
                }

                el.setAttribute('data-upsells-total-price', value)
                // Subtotal = Intelligems' tested price for this variant + selected add-ons.
                el.textContent = window.formatMoney(window.igGetSubtotalCents(el))
            })

            // Handle personalized gift note checkbox
            if (input.id === 'checkbox-personalized-gift-note') {
                const giftNoteFieldsWrapper = form.querySelector('#personalized-gift-note-fields-wrapper')
                const giftNoteOccasion = form.querySelector('#personalized-gift-note-occasion')
                const giftNoteMessage = form.querySelector('#personalized-gift-note-message')

                if (giftNoteFieldsWrapper && giftNoteOccasion && giftNoteMessage) {
                    if (e.target.checked) {
                        giftNoteFieldsWrapper.removeAttribute('hidden')
                        giftNoteOccasion.setAttribute('required', 'required')
                        giftNoteMessage.setAttribute('required', 'required')
                    } else {
                        giftNoteFieldsWrapper.setAttribute('hidden', 'hidden')
                        giftNoteOccasion.removeAttribute('required')
                        giftNoteMessage.removeAttribute('required')
                        giftNoteOccasion.value = ''
                        giftNoteMessage.value = ''
                    }
                }
            }
        })
    })

    form.querySelectorAll('.btn-atc').forEach((btn) => {
        btn.addEventListener('click', async (e) => {
            btn.classList.add('btn-loading')

            // if (btn.dataset.atcMode === 'checkout') {
            //     form.querySelector('[data-step="5"] [data-atc-mode="atc"]').style.visibility = 'hidden'
            // } else {
            //     form.querySelector('[data-step="5"] [data-atc-mode="checkout"]').style.visibility = 'hidden'
            // }

            form.querySelector('#btn-atc-bottom-alert').style.display = 'block'

            // const upsellItems = []

            // form.querySelectorAll('[data-step="4"] [type="checkbox"]:checked').forEach((checkbox) => {
            //     upsellItems.push({
            //         id: Number(checkbox.value),
            //         quantity: 1
            //     })
            // })
            // console.log(upsellItems)
            // console.log(`upsell addons checked adding ${upsellItems.length} items to cart`)
            // await fetch('/cart/add.js', {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json' },
            //     body: JSON.stringify({
            //         items: upsellItems
            //     })
            // })
            // console.log('sleeping for 5 seconds')
            // await sleep(5000);  
        })
    })

    // setInterval(() => {
    //     form.querySelectorAll('.btn-atc:not(.btn-loading').forEach((btn) => {
    //         btn.querySelector('span').textContent = 'Add to cart'
    //     })
    // }, 1000)

    window.addEventListener('scroll', () => {
        // A form the theme editor replaced is detached; let the new form's listener handle it
        if (!form.isConnected) { return }

        if (window.matchMedia('(max-width: 991px)').matches) {
            if (window.scrollY > form.getBoundingClientRect().bottom) {
                document.querySelectorAll('.custom-pet-portrait-btn-wrapper').forEach(elem => {
                    elem.classList.add('fixed-bottom')
                })
            } else {
                document.querySelectorAll('.custom-pet-portrait-btn-wrapper').forEach(elem => {
                    elem.classList.remove('fixed-bottom')
                })
            }
        }
    })
}
initCustomPetPortraitForm()

// Theme editor: a setting change re-renders the section with fresh markup, so rebind the form
document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('#form-custom-pet-portrait')) {
        e.target.querySelectorAll('.product-option').forEach(bindProductOption)
        e.target.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => bootstrap.Tooltip.getOrCreateInstance(el))
        initCustomPetPortraitForm()
    }
})

/*
    Quote Signs - custom form
*/
const initQuoteSignsForm = () => {
    const form = document.querySelector('#form-quote-signs')

    if (!form) { return }

    document.querySelectorAll('.form-step-btn-show-hide').forEach((btn) => {
        btn.addEventListener('click', () => {
            document.querySelector(`#form-step-${btn.dataset.hideStep}`).style.display = 'none'
            document.querySelector(`#form-step-${btn.dataset.showStep}`).style.display = 'block'

            setTimeout(() => {
                document.querySelector('#product-content-area').scrollIntoView({ behavior: 'smooth' })
            }, 250)
        })
    })

    document.querySelectorAll('#form-step-4 input[type="file"]').forEach((input, index) => {
        const pondPhoto = FilePond.create(input, {
            storeAsFile: true,
            acceptedFileTypes: ["image/jpg", "image/jpeg", "image/png", "image/gif", "image/bmp", "image/heic"],
            labelIdle: `<span class="filepond--drop-label--icon me-3"></span> Drag and drop your pet's photo ${index + 1} or <span class="filepond--label-action ms-1">Browse</span>`,
            imageResizeTargetWidth: 1200
        })

        pondPhoto.on('addfile', (error) => {
            if (!error) {
                document.querySelector(`#input-pet-name-${index + 1}-wrapper`).style.display = 'block'
            }
        })
    })

    document.querySelector('[data-step-4-confirm-next]').addEventListener('click', () => {
        let canContinue = true

        form.querySelectorAll('#form-step-4 [required]').forEach((elem) => {
            if (elem.type === 'file' && elem.files.length === 0) {
                canContinue = false
            } else if (elem.type === 'text' && elem.value.length === 0) {
                canContinue = false
            }
        })

        const alertElem = document.querySelector('#form-step-4-alert')

        if (!canContinue) {
            document.querySelector('#form-step-5').style.display = 'none'
            document.querySelector('#form-step-4').style.display = 'block'
            alertElem.style.display = 'block'
            alertElem.textContent = 'Please add all required information.'
        } else {
            alertElem.style.display = 'none'
            alertElem.textContent = ''
        }
    })

    form.querySelector('.btn-atc').addEventListener('click', async (e) => {
        const upsellItems = []

        form.querySelectorAll('#form-step-5 [type="checkbox"]').forEach((checkbox) => {
            if (checkbox.checked) {
                upsellItems.push({
                    id: Number(checkbox.value),
                    quantity: 1
                })
            }
        })

        // console.log(upsellItems)

        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: upsellItems
            })
        })
    })
}
initQuoteSignsForm()

//product style tool tips
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
          return new bootstrap.Tooltip(tooltipTriggerEl)
    })

// Personalized gift note checkbox handler for all forms
document.addEventListener('change', (e) => {
    if (e.target.id === 'checkbox-personalized-gift-note') {
        const form = e.target.closest('form')
        if (!form) return

        const giftNoteFieldsWrapper = form.querySelector('#personalized-gift-note-fields-wrapper')
        const giftNoteOccasion = form.querySelector('#personalized-gift-note-occasion')
        const giftNoteMessage = form.querySelector('#personalized-gift-note-message')

        if (giftNoteFieldsWrapper && giftNoteOccasion && giftNoteMessage) {
            if (e.target.checked) {
                giftNoteFieldsWrapper.removeAttribute('hidden')
                giftNoteOccasion.setAttribute('required', 'required')
                giftNoteMessage.setAttribute('required', 'required')
            } else {
                giftNoteFieldsWrapper.setAttribute('hidden', 'hidden')
                giftNoteOccasion.removeAttribute('required')
                giftNoteMessage.removeAttribute('required')
                giftNoteOccasion.value = ''
                giftNoteMessage.value = ''
            }
        }
    }
})

// Small adjustment for the product form
document.querySelectorAll('.product-option').forEach(option => {
    option.addEventListener('change', () => {

        if (option.value === 'Include Name') {
            const wrapper = option.closest('form').querySelector('#personalization-mug-input-name')?.closest('.form-control-wrapper')
    
            if (wrapper) {
                wrapper.removeAttribute('hidden')
            }
        } else if (option.value === 'No Name') {
            const wrapper = option.closest('form').querySelector('#personalization-mug-input-name')?.closest('.form-control-wrapper')
    
            if (wrapper) {
                wrapper.setAttribute('hidden', 'hidden')
            }
        }
        
        if (option.value === 'Name') {
            const wrapper = option.closest('form').querySelector('#input-pet-name-1')?.closest('.form-control-wrapper')
    
            if (wrapper) {
                wrapper.removeAttribute('hidden')
                wrapper.querySelector('.form-control').setAttribute('required', 'required')
            }
        } else if (option.value === 'No Name') {
            const wrapper = option.closest('form').querySelector('#input-pet-name-1')?.closest('.form-control-wrapper')
    
            if (wrapper) {
                wrapper.setAttribute('hidden', 'hidden')
                wrapper.querySelector('.form-control').removeAttribute('required')
            }
        }

        if (option.value === 'Name') {
            option.closest('form').querySelectorAll('[id*="personalization-pet-name"]').forEach(elem => {
                elem.closest('.form-control-wrapper').removeAttribute('hidden')
                elem.setAttribute('required', 'required')
            })
        } else if (option.value === 'No Name') {
            option.closest('form').querySelectorAll('[id*="personalization-pet-name"]').forEach(elem => {
                elem.closest('.form-control-wrapper').setAttribute('hidden', 'hidden')
                elem.removeAttribute('required')
            })
        }
    })
    
})